module.exports = __webpack_public_path__ + "img/14.7783aa77.png";